export default (theme) => ({
  circleLoader: {
    color: theme.colorPalette.white
  },
  spacing: {
    marginLeft: theme.spacing(2)
  }
});
